import { COLS, ROWS, cellKey } from './types'
import type { Board, Color } from './types'
import { genMoves } from './rules'

/**
 * 己方棋子所在格 + 己方所有棋子的 genMoves 目标格（含 `visionOnly` 炮架格）。
 * 逐条对应旧版 `computeVisible`。
 */
export function computeVisible(board: Board, color: Color): ReadonlySet<string> {
  const visible = new Set<string>()
  for (let r = 0; r < ROWS; r++) {
    for (let c = 0; c < COLS; c++) {
      const piece = board[r][c]
      if (piece && piece.color === color) {
        visible.add(cellKey(r, c))
        for (const move of genMoves(board, r, c)) visible.add(cellKey(move.r, move.c))
      }
    }
  }
  return visible
}

/**
 * 某一方**看不到**的格子（全集减去 `computeVisible`，行优先顺序）。
 * 观众的双视野遮罩直接用这个：`hiddenFromRed` / `hiddenFromBlack`。
 */
export function computeHidden(board: Board, color: Color): string[] {
  const visible = computeVisible(board, color)
  const hidden: string[] = []
  for (let r = 0; r < ROWS; r++) {
    for (let c = 0; c < COLS; c++) {
      const key = cellKey(r, c)
      if (!visible.has(key)) hidden.push(key)
    }
  }
  return hidden
}

/**
 * 全集减去给定集合：`computeHidden` 的逆运算，
 * 供观众「代入某方视角」时直接拿到「该方看得到」的格子集合。
 */
export function invertKeys(keys: ReadonlySet<string>): Set<string> {
  const result = new Set<string>()
  for (let r = 0; r < ROWS; r++) {
    for (let c = 0; c < COLS; c++) {
      const key = cellKey(r, c)
      if (!keys.has(key)) result.add(key)
    }
  }
  return result
}